import { routeUrl } from "@/app/routes";
import {
  READ_CARD_ROW_LIMIT,
  ReadCardFrame,
} from "@/features/copilot/components/read-cards/read-card-frame";
import type { PulseInsightItem } from "@/features/copilot/schemas/copilot-read-cards.schema";
import { UrgencyBadge } from "@/shared/components/pulse/badges";

/// Total over today's types; anything new reads as "Insight" rather than leaking a raw enum.
const INSIGHT_TYPE_LABEL: Record<string, string> = {
  trend: "Trend",
  root_cause: "Root cause",
  risk: "Risk",
  strength: "Strength",
  action: "Suggested action",
  weekly_brief: "Weekly brief",
  survey_run_report: "Survey report",
};

export function PulseInsightsReadCard({
  items,
  slug,
  hasMore = false,
}: {
  items: PulseInsightItem[];
  slug: string;
  hasMore?: boolean;
}) {
  const shown = items.slice(0, READ_CARD_ROW_LIMIT);
  return (
    <ReadCardFrame
      title="Pulse insights"
      viewAllHref={routeUrl.pulse.insights(slug)}
      hiddenCount={items.length - shown.length}
      hasMore={hasMore}
    >
      {shown.map((insight) => (
        <li key={insight.id}>
          <a
            href={routeUrl.pulse.insight(slug, insight.id)}
            className="block space-y-1 px-3 py-2 hover:bg-muted/60 focus-visible:outline-2 focus-visible:outline-ring"
          >
            <span className="flex items-center gap-2">
              {insight.urgency ? <UrgencyBadge level={insight.urgency} /> : null}
              <span className="text-xs text-text-secondary">
                {INSIGHT_TYPE_LABEL[insight.insightType] ?? "Insight"}
              </span>
            </span>
            {insight.untrustedSummary ? (
              <span className="line-clamp-2 break-words">{insight.untrustedSummary}</span>
            ) : null}
          </a>
        </li>
      ))}
    </ReadCardFrame>
  );
}
